import { render, staticRenderFns } from "./Curve.vue?vue&type=template&id=5a3446b8&"
import script from "./Curve.vue?vue&type=script&lang=js&"
export * from "./Curve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports